import "./style.css";
import { useState } from "react";
import { Description } from "@mui/icons-material";
import DownloadIcon from "@mui/icons-material/Download";
import DescriptionIcon from "@mui/icons-material/Description";
import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
import servDownloads from "../../../services/login/servDownloads";
import { style as modalStyle } from "../../../components/Loading/Loading";
import { downloadConteudoBase64 } from "../../../infra/utils/DownloadFile";
import { BlueHoverButton } from "../../../components/Inputs/BlueHoverButton";
import { Alert, Box, CircularProgress, Modal, Snackbar } from "@mui/material";

const DownloadCard = ({ documento }) => {
  const [uploadMessage, setUploadMessage] = useState("");
  const [openUpload, setOpenUpload] = useState(false);
  const [severity, setSeverity] = useState("info");
  const [isLoading, setIsLoading] = useState(false);

  const {
    Id,
    DataApresentacao,
    Descricao,
    NomeArquivo,
    TamanhoKb,
    TipoDocumento,
    Titulo,
  } = documento;

  const tipoDocumentoColorMap = {
    1: "#E3F2FD",
    2: "#E8F5E9",
    3: "#F3E5F5",
    4: "#FFF3E0",
  };

  const tipoDocumentoTextColorMap = {
    1: "#1976D2",
    2: "#2E7D32",
    3: "#7B1FA2",
    4: "#EF6C00",
  };

  const tipoDocumentoMap = {
    1: "Legislação",
    2: "Normas",
    3: "Modelos",
    4: "Manuais",
  };

  const formatarData = (data) => {
    if (!data) return "";

    if (data.includes("T")) {
      return new Date(data).toLocaleDateString("pt-BR");
    }

    const [dia, mes, ano] = data.split(" ")[0].split("/");

    return `${dia}/${mes}/${ano}`;
  };

  const extensao = NomeArquivo?.split(".").pop();

  const onClickDownload = async (event) => {
    event.preventDefault();

    try {
      setIsLoading(true);

      const response = await servDownloads.RealizarDownloadDocumento(Id);

      downloadConteudoBase64(
        response.Content.Nome,
        response.Content.Arquivo
      );

      setUploadMessage("Download realizado com sucesso");
      setSeverity("success");
      setOpenUpload(true);

    } catch (err) {
      setSeverity("error");
      setUploadMessage(
        err?.response?.data?.Message ||
        `${err?.response?.status} - ${err?.response?.statusText}`
      );
      setOpenUpload(true);
    } finally {
      setIsLoading(false);
    }
  };

  const handleCloseInfo = (event, reason) => {
    if (reason === 'clickaway') {
      setOpenUpload(false);
    }

    setOpenUpload(false);
  }

  return (
    <>
      <div className="download-card">
        <div className="card-header">
          <DescriptionIcon className="card-icon" style={{ color: '#6D79EC' }} />
          <span
            className="card-tag"
            style={{
              backgroundColor: tipoDocumentoColorMap[TipoDocumento],
              color: tipoDocumentoTextColorMap[TipoDocumento],
              padding: "4px 10px",
              borderRadius: "20px",
              fontSize: "12px",
              fontWeight: 500,
            }}
          >
            {tipoDocumentoMap[TipoDocumento]}
          </span>
        </div>

        <p className="card-title">{Titulo}</p>

        <p className="card-description">{Descricao}</p>

        <div className="card-info">
          <div className="info-row">
            <CalendarTodayIcon className="info-icon" style={{ color: '#6D79EC' }} />
            <span>{formatarData(DataApresentacao)}</span>
          </div>

          <div className="info-row">
            <Description className="info-icon" style={{ color: '#6D79EC' }} />
            <span>
              {TamanhoKb} KB - {extensao?.toUpperCase()}
            </span>
          </div>
        </div>

        <BlueHoverButton
          variant="contained"
          onClick={onClickDownload}
          sx={{
            backgroundColor: "#222222",
            border: "1px solid #2F2F2F",
            color: "#FFFFFF",
            "&:hover": {
              backgroundColor: "#6D79EC",
              border: "1px solid #6D79EC",
            },
            transition: "all 0.2s ease",
          }}
        >
          <DownloadIcon sx={{ marginRight: "5px" }} />
          Baixar arquivo
        </BlueHoverButton>
      </div>

      <Modal open={isLoading} >
        <Box style={modalStyle} >
          <CircularProgress color="inherit" />
        </Box>
      </Modal>

      <Snackbar open={openUpload} anchorOrigin={{ vertical: 'top', horizontal: 'right' }} autoHideDuration={1000} onClose={handleCloseInfo}>
        <Alert onClose={handleCloseInfo} severity={severity} sx={{ width: '100%' }} >
          {uploadMessage}
        </Alert>
      </Snackbar>
    </>
  );
};

export default DownloadCard;